var _defs, _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack387({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 8,
    rx: 7,
    ry: 7.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.93,10.73V5H5.69a1.83,1.83,0,0,1,.85.17,1.25,1.25,0,0,1,.51.51,1.51,1.51,0,0,1,.2.78,1.41,1.41,0,0,1-.17.71,1.3,1.3,0,0,1-.48.51,1.32,1.32,0,0,1,.64.5,1.58,1.58,0,0,1,.24.89,1.8,1.8,0,0,1-.22.91,1.34,1.34,0,0,1-.56.57,2.23,2.23,0,0,1-1,.18Zm.62-3.32h1a2,2,0,0,0,.57-.06.68.68,0,0,0,.37-.27.93.93,0,0,0,.13-.53A1,1,0,0,0,6.52,6a.64.64,0,0,0-.32-.29,2.27,2.27,0,0,0-.71-.07H4.55Zm0,2.64H5.72A1.61,1.61,0,0,0,6.29,10a.84.84,0,0,0,.41-.33,1.17,1.17,0,0,0,.14-.59,1.07,1.07,0,0,0-.14-.55.8.8,0,0,0-.36-.32,1.69,1.69,0,0,0-.7-.11H4.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.32,10.73V5h2.09a2.16,2.16,0,0,1,1,.16,1.25,1.25,0,0,1,.51.53,1.86,1.86,0,0,1,.2.87,1.46,1.46,0,0,1-1.32,1.56,1.51,1.51,0,0,1,.4.32,4.19,4.19,0,0,1,.48.73l.82,1.56h-.78l-.62-1.19a8.45,8.45,0,0,0-.55-.94,1.17,1.17,0,0,0-.36-.33,1.1,1.1,0,0,0-.49-.09H9v2.55ZM9,7.53h1.33A1.69,1.69,0,0,0,11,7.42a.75.75,0,0,0,.35-.33,1,1,0,0,0,.14-.53.91.91,0,0,0-.26-.68,1.06,1.06,0,0,0-.75-.25H9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack387);
export default __webpack_public_path__ + "static/media/Symbol_pack_387.164b0e0d72abc98f87d836511ba89455.svg";
export { ForwardRef as ReactComponent };